module.exports = __webpack_public_path__ + "img/2308-lounge1.59fe01e5.png";